import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { QuickAddService } from '../../services/quick-add.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ClientViewModel } from '../../models-views/client.view.model';
import { AppCommon } from '../../providers/app-common';
import { takeUntil, distinctUntilChanged, filter, debounceTime, Subject } from 'rxjs';
import { CountryCode } from '../../models/client.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-client-drawer',
  standalone: false,
  templateUrl: './client-drawer.component.html',
  styleUrl: './client-drawer.component.scss'
})
export class ClientDrawerComponent  {
  @Input() isVisible = false;
  @Input() data :any;
  isSubmitting: boolean = false;
  @Output() closeDrawer = new EventEmitter<boolean>();
  clientForm: FormGroup;
  isVisibleAddPoc: boolean = false;
  isVisibleAddAddress:boolean = false
  inputValue?: string;
  addressData:any
  page:number = 1;
  page_size:number = 300;
  userlist:any[] = []
  countryCodeList:any = []
  editPocData:any
  loggedInUser :any
  private destroy$ = new Subject<void>();
    
  constructor(
    private fb: FormBuilder,
    private message: NzMessageService,
    private quickAddService: QuickAddService,
    private vm:ClientViewModel,
    private cd: ChangeDetectorRef,
    private router: Router,
  ) {

    this.loggedInUser = AppCommon.getloggedInObject().user

    this.initForm();

    this.vm.userList.subscribe(data => {
      this.userlist = data.results
    })

    this.vm.countryCodeList.subscribe(data => {
      this.countryCodeList = data.results
    })
    
   
   
    // Listen for changes in the 'website' input field
    this.clientForm.get('website')?.valueChanges.subscribe((value) => {
      if (value && value.includes('https://')) {
        // Remove 'https://' from the input value
        const sanitizedValue = value.replace('https://', '');
        // Update the form control with the sanitized value
        this.clientForm.get('website')?.setValue(sanitizedValue, { emitEvent: false });
      }
    });
    this.clientForm.get('linkedin')?.valueChanges.subscribe((value) => {
      if (value && value.includes('https://')) {
        // Remove 'https://' from the input value
        const sanitizedValue = value.replace('https://', '');
        // Update the form control with the sanitized value
        this.clientForm.get('linkedin')?.setValue(sanitizedValue, { emitEvent: false });
      }
    });

    if(this.clientForm.get('poc')?.value.length == 1){
      let  formData = this.clientForm.get('poc')?.value[0]
      formData.type = 1
      this.clientForm.get('poc')?.setValue(formData);
    }

    
  
  }

  
  ngOnInit(): void {
    this.vm.parentClientDrawerComponent = this;
    this.vm.getUserList(this.page,this.page_size)
    this.vm.getCountryCodeList()
    this.vm.getCountryList(this.page,this.page_size)
    this.setupPOCListener();
  }
   
  ngOnChanges(changes: SimpleChanges): void {
    if(this.data && changes['data'].currentValue){
      let FormData = {
        name: changes['data'].currentValue.name,
        website: changes['data'].currentValue.website.replace('https://', '').replace('http://', ''),
        phone: changes['data'].currentValue.phone,
        country_code: changes['data'].currentValue.country_code,
        linkedin: changes['data'].currentValue.linkedin.replace('https://', '').replace('http://', ''),
        job_title: changes['data'].currentValue.job_title || '',
        onboarding_date: changes['data'].currentValue.onboarding_date || null,
        address:changes['data'].currentValue.address,
        poc: changes['data'].currentValue.poc_details,
        salesperson: changes['data'].currentValue.salesperson,
      }
      console.log(FormData)
      this.clientForm.patchValue(FormData)
    }
   
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  initForm() {
    this.clientForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(200)]],
      website: ['', [Validators.required,Validators.pattern('^[a-zA-Z0-9./-]+$')]],
      phone: [''],
      country_code: [''],
      country: [''],
      linkedin: [''],
      job_title: [''],
      onboarding_date: [null],
      address:[[],Validators.required],
      poc: [[]],
      salesperson: [null, Validators.required]
    });
  }

  open() {
    this.isVisible = true;
  }

 
     
  close(): void {
    this.quickAddService.refreshData.next(true);
    this.isVisible = false;
    this.closeDrawer.emit(false);
    this.addressData = undefined
    this.editPocData = undefined
    this.clientForm.reset();
    
  }

  closeonly(){
    this.clientForm.reset();
    this.isVisible = false;
    this.closeDrawer.emit(false);
    this.addressData = undefined
    this.editPocData = undefined
  }

  // onChange(value: string): void {
  //   console.log(value);
  // }


  openAddPoc() {
    this.isVisibleAddPoc = true;
    this.editPocData = undefined
  }
  openAddAddress() {
    this.isVisibleAddAddress = true;
    this.addressData = undefined
  }


  getCountryCode(id:any){
    return id != null && this.countryCodeList != null ? this.countryCodeList.filter(e => e.id == id)[0]?.code : ''

  }

  closeAddPoc(poc:any){
    // console.log(poc)
    if(poc && !this.editPocData) {
      // Adding new POC
      const currentPocs = this.clientForm.get('poc')?.value || [];
      this.clientForm.get('poc')?.setValue([...currentPocs, poc ]);
    } else {
      // Updating existing POC
      const currentPocs = this.clientForm.get('poc')?.value || [];
      const updatedPocs = currentPocs.map((item: any) => {
        // Match by ID if available, otherwise match by email (for POCs not yet saved to DB)
        const isMatch = poc.id && item.id ? item.id === poc.id : item.poc_email === this.editPocData.poc_email;
        return isMatch ? { ...item, ...poc } : item;
      });
      this.clientForm.get('poc')?.setValue(updatedPocs);
    }
    this.isVisibleAddPoc = false;
   
  }

   setupPOCListener() {
    this.clientForm.get('poc')?.valueChanges.pipe(
      takeUntil(this.destroy$),
      distinctUntilChanged(),
      debounceTime(300)
    ).subscribe((value) => {
      if (!value || value.length === 0) return;
  
      // Case 1: Single entry - set type to 1
      if (value.length === 1) {
        const current = value[0];
        if (current.type !== 1) {
          const formData = {...current, type: 1};
          this.clientForm.get('poc')?.patchValue([formData], { emitEvent: false });
        }
      }
       
    });
  }

  trackByPocId(index: number, poc: any): any {
    return poc.id || index; // Use a unique identifier
  }

  closeAddAddress(address: any) {
    const currentAddresses = this.clientForm.get('address')?.value || [];
     const newAddress = {
        address_field_1: address.address_field_1,
        address_field_2: address.address_field_2,
        country: address.country.id,
        country_name: address.country.name,
        state: address.state.id,
        state_name: address.state.name,
        city: address.city.id,
        city_name: address.city.name,
        zip_code: address.zip_code,
        address_type: address.address_type.id,
        address_type_name: address.address_type.name
      };
    if (address && !this.addressData) {
      // Adding a new address
      this.clientForm.get('address')?.setValue([...currentAddresses, newAddress]);
    } else {
      // Editing an existing address  
      const updatedAddresses = currentAddresses.map((item: any) =>
        item.id === address.id ? { ...item, ...newAddress } : item
      );
      this.clientForm.get('address')?.setValue(updatedAddresses);
    }  
  }

  deleteAddress(address: any) {
    const currentAddresses = this.clientForm.get('address')?.value || [];
    const updatedAddresses = currentAddresses.filter((item: any) => item.id !== address.id);
    this.clientForm.get('address')?.setValue(updatedAddresses);
    
    // Call API to delete address from backend if address has an ID (existing address)
    if (address.id) {
      this.vm.deleteClientAddress(address.id);
    }
  }

  deletePOC(poc: any) {
    const currentpoc = this.clientForm.get('poc')?.value || [];
    const updatedpoc = currentpoc.filter((item: any) => item.id !== poc.id);
    this.clientForm.get('poc')?.setValue(updatedpoc);
    
    // Call API to delete POC from backend if POC has an ID (existing POC)
    if (poc.id) {
      this.vm.deletePOC(poc.id);
    }
  }
  
  updateAddress(data:any){
    // console.log(data)
    this.addressData = data
    this.isVisibleAddAddress = true
  }

  editPOC(poc:any){
    this.editPocData = poc
    this.isVisibleAddPoc = true;
  }

  closeAddPocEvent(poc: any) {
    this.editPocData = null
    this.isVisibleAddPoc = false;
  }

  closeAddAddressEvent(poc: any) {
    this.addressData = null
    this.isVisibleAddAddress = false;
  }

  markPrimary(pocs:any){
    this.clientForm.get('poc')?.value.forEach((poc:any) => {
      poc.type = 2
    });
    let poc = pocs
    poc.type = 1
  }

  onSubmit() {
    if (this.clientForm.invalid) {
      this.markFormGroupTouched(this.clientForm);
      this.message.error('Please fill all required fields correctly');
      return;
    }

    const formValue = JSON.parse(JSON.stringify(this.clientForm.value))
    
    formValue.website.length > 0 && (formValue.website = 'https://' + formValue.website);
    formValue.linkedin.length > 0 && (formValue.linkedin = 'https://' + formValue.linkedin);
    
    // Convert empty string to null for optional date field
    if (!formValue.onboarding_date || formValue.onboarding_date === '') {
      formValue.onboarding_date = null;
    }
    
    if(this.data){
      delete formValue.address
      delete formValue.poc
      formValue['id'] = this.data.id 
      formValue['modified_by']  = this.loggedInUser.id;
      this.vm.updateClient(formValue)
    } else {
      formValue['created_by']  = this.loggedInUser.id
      this.vm.createClient(formValue);
    }
 
   
 
    

  }

  successUpdateCreate(e:any){
    // console.log(e)
    setTimeout(() => {
      this.router.navigate(['app/clients' , e.id])
    },1000)
    this.close();
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsDirty();
      control.updateValueAndValidity();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

 
  getIcon(name: string){
    return AppCommon.getDicebearIcon(name);
  }

  getMaxDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  


}

 